<a [routerLink]="['/profile-check/professions', profession.id]" class="vacancy-card vacancy-card--beroepen">
  <div class="vacancy-card__title-row">
    <h3 class="vacancy-card__title">{{ profession.title }}</h3>
    <div class="vacancy-match-bar">
      <div class="vacancy-match-bar__fill" [style.width.%]="profession.matchScore">
        <span class="vacancy-match-bar__label">{{ profession.matchScore }}%</span>
      </div>
    </div>
  </div>

  <p class="vacancy-card__subtitle" style="font-weight: 500; color: #222;">{{ profession.sector }}</p>
  <p class="vacancy-card__subtitle">{{ 'professions.card.level_prefix' | translate }} {{ profession.level }}</p>

  <div class="profession-card__footer">
    <div class="vacancy-tags">
      <span *ngFor="let tag of profession.tags" class="vacancy-tag">{{ tag }}</span>
    </div>
    <div class="vacancy-card__actions">
      <button
        class="vacancy-btn-round vacancy-btn-heart"
        [class.vacancy-btn-heart--active]="isLiked"
        (click)="onLike($event)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" [attr.fill]="isLiked ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>
        </svg>
      </button>
      <span class="vacancy-btn-round vacancy-btn-arrow">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
        </svg>
      </span>
    </div>
  </div>
</a>
